import { EventEmitter, Injectable } from '@angular/core';
import { NotificationType } from '../models/notification-type';
import { NotificationMessage } from '../models/notification-message';

@Injectable()
export class NotificationService {

  readonly navigateToMessage: EventEmitter<any> = new EventEmitter<any>();

  private _messages = new Map<string, NotificationMessage>();

  show(uniqueName: string, massage: string, type: NotificationType = NotificationType.Error): void {
    this._messages.set(uniqueName, new NotificationMessage(massage, type));
  }

  hide(uniqueName: string): void {
    if (!uniqueName) {
      return;
    }
    this._messages.delete(uniqueName);
  }

  hideAll(): void {
    this._messages.clear();
  }

  get messages(): NotificationMessage[] {
    return Array.from(this._messages.values()).filter(item => item.message);
  }

  scrollToMessage(): void {
    this.navigateToMessage.emit();
  }
}
